import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;
  padding: 0;

  @media (max-width: 768px) {
    // margin: 0 auto 50px;

    // padding: 100px;
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
    width: 100%;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 3rem;
    font-size: var(--fz-l);
    font-weight: 500;
    text-align: center;
    white-space: nowrap;

    .mobile-copy {
      display: none;
    }

    @media (max-width: 768px) {
      white-space: normal;
      line-height: 1.15;

      .desktop-copy {
        display: none;
      }

      .mobile-copy {
        display: inline;
      }
    }
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, [prefersReducedMotion]);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>

      <span>
        <h2 className="title">Ready for Next <span style={{ color: 'var(--green)' }}>Collaboration?</span></h2>
      </span>


      <p>
        I am interested in challenging backend, blockchain, ZK, cryptography, and full-stack systems where performance and reliability matter.
        Let's discuss how I can contribute to your team.
      </p>

      <a className="email-link" href={`mailto:${email}`}>
        <span className="desktop-copy">Collaborate with me</span>
        <span className="mobile-copy">
          Collaborate with
          <br />
          me
        </span>
      </a>
    </StyledContactSection>
  );
};

export default Contact;
